import { GET_ADMIN_FIELD_MANAGEMENT,GET_ADMIN_FIELD_TYPE} from '../types'

const INITIAL_STATE = {
  allFieldsManag: {},
  allFieldsType:{}

}

const adminFormFieldReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case GET_ADMIN_FIELD_MANAGEMENT:
      return {
        ...state,
        allFieldsManag: payload?.data,
      }
      case GET_ADMIN_FIELD_TYPE:
        return {
          ...state,
          allFieldsType: payload?.data,
        }

    default:
      return state
  }
}

export default adminFormFieldReducer
